import React, { useState, useEffect } from "react";

import agricultureImg from "../../assets/agriculture.png";
import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";

import { FaRobot } from "react-icons/fa";
import { GiWheat } from "react-icons/gi";

function useWindowWidth() {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  useEffect(() => {
    const handler = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return width;
}

function AgriculturePage() {
  const [openIndex, setOpenIndex] = useState(null);
  const width = useWindowWidth();

  const isMobile = width < 640;
  const isTablet = width >= 640 && width < 1024;

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Enabling better decision-making",
      content:
        "Analyzing market demand, estimating and sowing prices, determining the right time for harvesting .For all this to make better decisions at every stage of the crop cultivation process."
    },
    {
      title: "2.Cost Reduction",
      content:
        "Precision farming combines best soil management practices, variable rate technology and highly effective data management.It helps in reduced use of herbicides, better crop quality, higher profits and more cost savings."
    },
    {
      title: "3.Solves labor shortages",
      content:
        "Driverless tractors, AI-based robots for smart irrigation and fertilizing systems, smart spraying, vertical farming software and harvesting .All these help in less manpower."
    },
    {
      title: "4.Early detection of pests, disease, and weeds",
      content:
        "The Field images can be provided to the Convolution Neural Network, which is trained to detect the onset of disease by observing leaf discoloration."
    },
    {
      title: "5.Precision agriculture",
      content:
        "Can detect multiple conditions required for proper cultivation such as soil moisture conditions, light, humidity and real time temperature. Which results in massive savings in water and pesticides being used."
    }
  ];

  return (
    <div>

      {/* HEADER */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          height: isMobile ? "auto" : "110px",
          borderTop: "1px solid #e5e5e5",
          borderBottom: "1px solid #e5e5e5"
        }}
      >
        {/* LEFT */}
        <div
          style={{
            flex: 1.5,
            position: "relative",
            backgroundImage: `url(${bannerImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            alignItems: "center",
            padding: isMobile ? "16px 14px" : "0 20px",
            minHeight: isMobile ? "80px" : "auto"
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(47,183,164,0.7)"
            }}
          />

          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              gap: "12px",
              background: "rgba(0,0,0,0.15)",
              padding: isMobile ? "10px 14px" : "14px 22px",
              borderRadius: "6px",
              color: "#fff",
              width: isMobile ? "100%" : isTablet ? "380px" : "520px",
              fontFamily: "Arial"
            }}
          >
            <div
              style={{
                width: "36px",
                height: "36px",
                flexShrink: 0,
                background: "#1f7f73",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span
              style={{
                fontSize: isMobile ? "14px" : "16px",
                fontWeight: "500"
              }}
            >
              Artificial Intelligence - Use Cases
            </span>

            <span style={{ marginLeft: "auto", fontSize: "28px" }}>›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div
          style={{
            flex: 1,
            background: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            minHeight: isMobile ? "70px" : "auto"
          }}
        >
          {/* left triangle — hide on mobile */}
          {!isMobile && (
            <div
              style={{
                position: "absolute",
                left: 0,
                height: "100%",
                width: "80px",
                background:
                  "linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f)",
                clipPath: "polygon(0 0, 60% 0, 0 100%)"
              }}
            />
          )}

          {/* right triangle — hide on mobile */}
          {!isMobile && (
            <div
              style={{
                position: "absolute",
                right: 0,
                height: "100%",
                width: "80px",
                background:
                  "linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f)",
                clipPath: "polygon(100% 0, 100% 100%, 40% 100%)"
              }}
            />
          )}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px"
            }}
          >
            <GiWheat
              style={{
                fontSize: isMobile ? "28px" : "38px",
                color: "#25c3a6"
              }}
            />

            <h2
              style={{
                margin: 0,
                fontSize: isMobile ? "22px" : isTablet ? "26px" : "30px",
                fontWeight: "600",
                color: "#243b64",
                fontFamily: "Arial"
              }}
            >
              Agriculture
            </h2>
          </div>
        </div>
      </div>

      {/* MAIN SECTION */}
      <div
        style={{
          display: "flex",
          flexDirection: isMobile || isTablet ? "column" : "row",
          padding: isMobile
            ? "30px 18px"
            : isTablet
            ? "40px 36px"
            : "60px 80px",
          gap: isMobile ? "30px" : isTablet ? "40px" : "60px",
          alignItems: isMobile || isTablet ? "stretch" : "center",
          background: "#f5f5f5"
        }}
      >
        {/* LEFT IMAGE */}
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center"
          }}
        >
          <img
            src={agricultureImg}
            alt="Agriculture"
            style={{
              width: "100%",
              maxWidth: isMobile ? "100%" : isTablet ? "500px" : "650px",
              display: "block"
            }}
          />
        </div>

        {/* RIGHT ACCORDION */}
        <div style={{ flex: 1.2 }}>
          {data.map((item, i) => (
            <div key={i} style={{ marginBottom: "14px" }}>
              <div
                onClick={() => toggle(i)}
                style={{
                  background:
                    "linear-gradient(90deg,#2fb7a4 0%,#2f6f9f 60%,#2f4a7f)",
                  color: "#f4f7fb",
                  padding: isMobile ? "8px 14px" : "8px 24px",
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: isMobile ? "14px" : isTablet ? "15px" : "17px",
                  fontFamily: "Arial",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  minHeight: "52px"
                }}
              >
                {item.title}

                <span
                  style={{
                    fontSize: "22px",
                    fontWeight: "500",
                    flexShrink: 0,
                    marginLeft: "10px"
                  }}
                >
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div
                  style={{
                    padding: isMobile ? "14px 16px" : "18px 28px",
                    color: "#555",
                    lineHeight: "1.8",
                    fontSize: isMobile ? "14px" : "16px",
                    fontFamily: "Arial",
                    fontWeight: "400",
                    background: "#f5f5f5"
                  }}
                >
                  {item.content}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AgriculturePage;
